import { TokenExCardTranslations } from '../../../hooks/TokenEx/utils';
import { createSafeContext } from '../../../utils';

const [CartInfoProvider, useCartInfoContext] = createSafeContext<{
  storeId?: string;
  storeItemId?: string;
  cartId?: string;
  pendingCardType?: TokenExCardTranslations;
}>('CartInfoProvider component was not found in tree');

export { CartInfoProvider, useCartInfoContext };
